const GlobalSettings = {
    languageId: 1,
    stateDraft: 1, // noch nicht freigegeben
    stateActive: 2, // 
    stateProgress: 3, // freigegeben
    stateBreak: 4, // pausiert
    stateEnded:5, // beendet
    stateTerminated: 6, // abgebrochen
    stateSupplied: 7, // in Auswertung
    // State 2 and 3 define whether the survey is open for answers, any other status means that the survey isn't 
    debugMode: '', // "Main Use"  at the moment: display console.logs when 'on', Relevant console.log-are to be encapsulated by if(GlobalSettings.debugMode === 'on')
    previewMode: 'on', // shows Survey regardless of state, won't save results, even if debugModeWithSaving is activated
    debugModeWithSaving: false, // mit Speichern
    debugModeDefaultSurvey: 106, // default Survey-Id
    }

export default GlobalSettings;